import { DisplayLogic } from '@common/entities';

import { ConditionalElementState } from 'hooks/display-logic';
import { Block, Field } from 'types/fields';
import { BlankPage } from 'types/page';

type DisplayConditionEvaluator = (displayLogic?: DisplayLogic) => ConditionalElementState;

export const isPageFullyHidden = (
  page: BlankPage,
  evaluateDisplayCondition: DisplayConditionEvaluator,
): boolean => {
  const { sections = [] } = page;

  if (!sections.length) return true;

  return sections.every((section) => {
    if (
      section.displayLogic &&
      evaluateDisplayCondition(section.displayLogic) === ConditionalElementState.Hidden
    ) {
      return true;
    }

    return section.elements.every(
      (element: Block | Field) =>
        Boolean(element.displayLogic) &&
        evaluateDisplayCondition(element.displayLogic) === ConditionalElementState.Hidden,
    );
  });
};
